export default __webpack_public_path__ + "static/media/logo-sm.30bd855b.png";